// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2GTBa","right":"styles_right__Jfdrw"};